import { Component, OnInit, OnDestroy } from "@angular/core";
import { Observable, of, Subscription } from "rxjs";
import { PopupsService } from "../popups/popups.service";
import { UsuarioPreferenciasService } from "../../services/data-services/usuario.preferencias.service";
import { CheckForUpdateService } from "../../services/check-for-update.service";
import { StatusService } from "../../services/status.service";
import { AuthService } from "../../modules/shared/services/auth.service";
import { UiService } from "../../services/ui.service";
import { NavegacaoPesquisaLeisService } from "./navegacao-pesquisa-leis/navegacao-pesquisa-leis.service";
import { ErrorHandlerService } from "src/app/services/errorHandler.service";
import { NavbarModel } from "src/app/models/NavbarModel";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit, OnDestroy {
  public updateAvailable$: Observable<boolean> = of(false);
  public appOffline$: Observable<boolean> = of(false);

  public exibirNavegacaoPesquisaMobile$: Observable<boolean> = of(false);

  quantidadeItensRevisao = 0;
  subscriptions: Subscription[] = [];

  public breakpointLg$: Observable<boolean> = of(false);
  public model = new NavbarModel();

  public breakpointMd$: Observable<boolean> = of(false);

  constructor(
    public auth: AuthService,
    private popupsService: PopupsService,
    private usuarioPreferenciasService: UsuarioPreferenciasService,
    public checkForUpdateService: CheckForUpdateService,
    public statusService: StatusService,
    public uiService: UiService,
    private navegacaoPesquisaLeisService: NavegacaoPesquisaLeisService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  async atualizarApp() {
    await this.checkForUpdateService.updateApplication();
  }

  ngOnInit() {
    this.updateAvailable$ =
      this.checkForUpdateService.getHistoricoAtualizacoesLeis();
    this.appOffline$ = this.statusService.getAppOffline();
    this.subscriptions.push(
      this.usuarioPreferenciasService.getConfiguracoes().subscribe((config) => {
        this.model = NavbarModel.fromUserData(config);
      })
    );

    this.breakpointLg$ = this.uiService.getBreakpointLg();

    this.exibirNavegacaoPesquisaMobile$ =
      this.navegacaoPesquisaLeisService.getExibirNavegacaoPesquisaMobile();

    this.breakpointMd$ = this.uiService.getBreakpointMd();
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
  }

  logoff() {
    this.auth
      .logoff()
      .catch((error) => this.errorHandlerService.handleError(error));
  }

  lnkPreferenciasClick(event: Event) {
    event.preventDefault();
    this.popupsService.abrirPopupPreferencias();
  }

  public lnkPerfilClick(e: Event): void {
    e.preventDefault();
    this.popupsService.abrirPopupPerfil();
  }

  // novidadesClick() {
  //     this.paineisService.abrirPainelNovidades();
  // }

  exibirPesquisaMobileClick() {
    this.navegacaoPesquisaLeisService.updateExibirNavegacaoPesquisaMobile();
  }

  public btnFeedbackClick(): void {
    this.popupsService.abrirPopupFeedback();
  }
}
